const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function votingPdfMaker (row, votes, getMember, owners) {
  const result = row.passed ? 'accepted' : 'declined';
  const p = 'The proposal was ' + result + ' on ' + row.resolvedTime + '.';

  const rows: any[] = [];
  votes.forEach(vote => {
    const member = getMember(vote.voter);
    const resultText = vote.voterBalance > 0 ? ' Voted for (' : ' Voted against (';
    const text = member.name + resultText + Math.abs(vote.voterBalance) + ' shares):';
    const pdfRow = [
      {
        ul: [' ']
      },
      { text, alignment: 'left' }
    ];
    pdfRow.push(memberSign(member.name));
    rows.push(pdfRow);
  });

  function memberSign (name) {
    return { text: 'Signature: ' + name, alignment: 'right', italics: true };
  }

  const signRow: any = [];
  for (let addr in owners) {
    const footerRow: any[] = [];
    signRow.push([{ text: '\n' }, { text: '\n' }, { text: '\n' }, { text: '\n' }]);
    footerRow.push({});
    footerRow.push({ text: 'Director: ' + getMember(addr).name, alignment: 'right' });
    footerRow.push({ text: '', alignment: 'right' });
    footerRow.push(memberSign(getMember(addr).name));
    signRow.push(footerRow);
  }

  if (!rows.length) rows.push({});

  const dd = {
    // a string or { width: number, height: number }
    pageSize: 'A4',
    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: 'portrait',
    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [40, 40, 40, 40],
    content: [
      {
        text: row.subject,
        style: 'header',
        margin: [0, 0, 0, 5],
        fontSize: 22
      },
      {
        text: row.description,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 20]
      },
      {
        text: p,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 20]
      },
      {
        table: {
          widths: ['auto', '*', 'auto'],
          body: rows,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 150]
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: signRow,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false
      }
    ],
    styles: {
      header: {
        fontSize: 16,
        bold: true,
        alignment: 'justify'
      }
    }
  };
  return pdfMake.createPdf(dd);
}
